getExperiment = require 'lib/experiments/simple-test'

module.exports = {
  getUnreadNotifications: (model, modelCache, notificationsSeenState) ->
    notificationsCount = model.get('notificationsCount')
    countsByGroup = notificationsSeenState.getNewNotifications(notificationsCount)

    count = Object.keys(countsByGroup).length

    count
}



// WEBPACK FOOTER //
// ./app/scripts/models/internal/member-helper.coffee